/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { LegalEntityModel } from '@well/common-libs/legal-entity-management/domain-model';

export class DelServiceProviderDtoModel {
  uuid: string | undefined = undefined;
  legalEntity: LegalEntityModel | undefined = undefined;
  owner: string | undefined = undefined;
}
